import React from 'react'
import ReservationSummary from '../ ReservationSummary'
import { useUser } from '../context/UserContext';
import './reservationSummary.css'
import ProgressBar from '../components/ProgressBar'
import { useNavigate } from 'react-router-dom';

const RecommendationMsg = () => {
    const { setUser, setDate } = useUser();
    const navigate = useNavigate();

    const cleanToNewReservation = () => {
        setUser({
            docType: '',
            lastName: '',
            motherLastName: '',
            phone: '',
            secondaryPhone: '',
            email: '',
            docId: '',
            birthdate: '',
            healthInsurance: '',
            medicalplan: '',
            name: '',
            patientCod: '',
        });
        setDate({
            medico: '',
            docId: '',
            dia: new Date(),
            hourId: '',
            hora: '',
            isPreRegister: false
        });
        navigate('/');
    }

    return (
        <>
            <ProgressBar loadPercentage={100} />
            <div className='reservation-summary-container'>
                <ReservationSummary />
                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                    <p className='alert-title'>TENER EN CUENTA:</p>
                    <p>Estimado paciente, si usted usa lentes de contacto blandos, debe retirarlos 24 horas antes de la consulta.</p>
                    <p>Si son semirrígidos, debe retirarlos 48 horas antes de la consulta.</p>
                </div>
                <div className='confirmation-container'>
                    <p>Su reserva ha sido agendada con éxito.</p>
                    <p>Le sugerimos llegar con 15 minutos de anticipación.</p>
                    <p>Su hora será recordada a través de WhatsApp y confirmada vía teléfono.</p>
                </div>
                <div className="summary-footer">
                    <button onClick={() => cleanToNewReservation()}>Volver a agendar</button>
                </div>
            </div>
        </>
    )
}

export default RecommendationMsg
